import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <footer>
            <p className="footer">Made by <a href="https://github.com/PriscilaAlfaro" className="link-github" rel="noreferrer noopener" target="_blank">Priscila Alfaro Segura</a> & <a href="https://github.com/JuliaNiki" rel="noreferrer noopener" className="link-github" target="_blank">Julia Nikitina</a></p>
            <span role="img" aria-label="emoji-turtle" className="turtle">🐢</span>
            <p className="footer">Technigo bootcamp 2021</p>
        </footer>
    )
}

export default Footer